import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { Hyperlink } from "@ebsco-ui/ebsco-ui";
import sharedMessages from "../../../../shared-messages";
import SuccessIndicatorCard from "../../success-indicator-card";
import messages from "./account-created-indicator-messages";

import "./account-created-indicator.scss";

const block = "account-created-indicator";

const AccountCreatedIndicator = ({ signInUrl, intl: { formatMessage } }) => {
  const signInToContinue = formatMessage(messages.signInToContinue);
  const signIn = formatMessage(sharedMessages.signIn);
  return (
    <SuccessIndicatorCard title={formatMessage(messages.accountCreated)}>
      <p className={`${block}__description`}>{signInToContinue}</p>
      <Hyperlink
        href={signInUrl}
        styleType="highlighted"
        target="_self"
        className={`${block}__link`}
      >
        {signIn}
      </Hyperlink>
    </SuccessIndicatorCard>
  );
};

AccountCreatedIndicator.propTypes = {
  signInUrl: PropTypes.string.isRequired
};

export { AccountCreatedIndicator };
export default injectIntl(AccountCreatedIndicator);
